import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const CUST_TOKEN = "pc_customer_token";

export const custApi = axios.create({ baseURL: `${BASE}/api` });
custApi.interceptors.request.use((c) => {
  const t = localStorage.getItem(CUST_TOKEN);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const getPoojas = (cat) =>
  custApi.get("/poojas", { params: cat && cat !== "All" ? { category: cat } : {} }).then((r) => r.data);
export const browsePriests = (params) => custApi.get("/priests", { params }).then((r) => r.data);
export const createRequest = (body) => custApi.post("/requests", body).then((r) => r.data);
export const getRequests = () => custApi.get("/requests").then((r) => r.data);
export const acceptProposal = (reqId, proposalId) =>
  custApi.post(`/requests/${reqId}/accept`, { proposal_id: proposalId }).then((r) => r.data);
export const getBookings = () => custApi.get("/bookings").then((r) => r.data);

export const puroMitraHistory = () => custApi.get("/customer/puromitra/history").then((r) => r.data);
export const puroMitraChat = (message) => custApi.post("/customer/puromitra", { message }).then((r) => r.data);

export const geoAutosuggest = (q) => custApi.get("/geo/autosuggest", { params: { q } }).then((r) => r.data.suggestions);

export const custLogin = (email, password) => custApi.post("/auth/login", { email, password }).then((r) => r.data);
export const custRegister = (b) => custApi.post("/auth/register", b).then((r) => r.data);
export const custMe = () => custApi.get("/auth/me").then((r) => r.data);

export function apiErr(e, fb = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.[0]?.msg || e?.message || fb;
}
